import GroupsEnum from './GroupsEnum';

/**
 * reference: Valeur de l'énumération, sauvegardé en base de donnée pour chaque utilisateurs affiliés
 * name: Nom du groupe en front
 * visible: Définit si le groupe peut être attribué ou non à un ensemble d'utilisateurs (exemple: on ne peut pas attribuer d'autre SUPER_ADMIN aka Direction)
 * access: Liste des différentes autorisation possible
 * detailsAccess: Description des access
 * color et txtColor: Couleur de fond et du texte pour les badges coté front
 * @type {*[]}
 */
const groups = [
  {
    reference: GroupsEnum.SUPER_ADMIN,
    name: 'Direction',
    visible: false,
    color: '#d2d6e6',
    access: ['1'],
    detailsAccess: {
      1: 'Illimité',
    },
  },
  {
    reference: GroupsEnum.ADMIN,
    name: 'Administration',
    visible: true,
    color: '#c9ef74',
    access: ['1', '2', '3'],
    permissionsToSet: [GroupsEnum.SUPER_ADMIN, GroupsEnum.ADMIN],
    detailsAccess: {
      1: 'Création de compte',
      2: 'Edition de compte',
      3: 'Listing des comptes',
    },
  },
  {
    reference: GroupsEnum.IN_CHARGE,
    name: 'Responsable',
    visible: true,
    color: '#8a6eef',
    txtColor: '#ffffff',
    access: ['1', '2', '3'],
    permissionsToSet: [
      GroupsEnum.SUPER_ADMIN,
      GroupsEnum.ADMIN,
      GroupsEnum.IN_CHARGE,
    ],
    detailsAccess: {
      1: 'Création de compte (global)',
      2: 'Edition de compte sous sa responsabilité',
      3: 'Listing des comptes sous sa responsabilité',
    },
  },
  {
    reference: GroupsEnum.COMPTA,
    name: 'Comptabilité',
    visible: true,
    permissionsToSet: [GroupsEnum.SUPER_ADMIN, GroupsEnum.ADMIN],
    color: '#ef8a85',
    access: ['1'],
    detailsAccess: {
      1: 'Gestion des congés',
    },
  },
  {
    reference: GroupsEnum.ANIMATEUR,
    name: 'Animateur',
    visible: true,
    color: '#5cbaef',
    txtColor: '#ffffff',
    access: [],
    detailsAccess: {},
  },
  {
    reference: GroupsEnum.RECEPTIONIST,
    name: 'Réceptionniste',
    visible: true,
    color: '#FFB400',
    txtColor: '#ffffff',
    access: ['1'],
    detailsAccess: {
      1: 'Gestion des minibus',
    },
  },
  {
    reference: GroupsEnum.CEE_ADMIN,
    name: 'CEE Admin',
    visible: true,
    color: '#007bff',
    txtColor: '#ffffff',
    access: ['1'],
    detailsAccess: {
      1: 'Création, Edition, et Listing des CEE',
    },
  },
  {
    reference: GroupsEnum.MINIBUS_ADMIN,
    name: 'Minibus Admin',
    visible: true,
    color: '#28a745',
    txtColor: '#ffffff',
    access: ['1'],
    permissionsToSet: [
      GroupsEnum.SUPER_ADMIN,
      GroupsEnum.ADMIN,
    ],
    detailsAccess: {
      1: 'Validation des demandes de minibus',
    },
  },
];

export default groups;
